"use client";

import CC_ICON from "@assets/svg/check-circe-icon.svg";
import Image from "next/image";
import { ReactNode, useState } from "react";
import { ExtendedStoreProduct } from "types/global";
import Accordion from "./accordion";

type ProductTabsProps = {
  product: ExtendedStoreProduct;
  isOutOfStock: boolean;
};

const ProductTabs = ({ product, isOutOfStock }: ProductTabsProps) => {
  const tabs = [
    {
      label: "Thông tin sản phẩm",
      component: <ProductInfoTab product={product} isOutOfStock={isOutOfStock} />,
    },
    {
      label: "Thông số kỹ thuật",
      component: <ProductParameterTab product={product} isOutOfStock={isOutOfStock} />,
    },
  ];

  return (
    <div className="w-full">
      <Accordion type="multiple" defaultValue={tabs.map((tab) => tab.label)}>
        {tabs.map((tab, i) => (
          <Accordion.Item key={i} title={tab.label} headingSize="medium" value={tab.label}>
            {tab.component}
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

const ProductInfoTab = ({ product, isOutOfStock }: ProductTabsProps) => {
  const convertWarrantyUnit = (key: any) => {
    switch (key) {
      case "MONTH":
        return " tháng";
      case "YEAR":
        return " năm";
      case "DAY":
        return " ngày";
      default:
        return "--";
    }
  };

  const productInfo = [
    {
      label: "Thương hiệu",
      value: product.brand?.name || "--",
    },
    {
      label: "Mã sản phẩm",
      value: product.variants?.[0].sku || "--",
    },
    {
      label: "Bảo hành",
      value:
        (product.variants?.[0]?.metadata?.warranty || "--") +
        convertWarrantyUnit(product.variants?.[0]?.metadata?.warranty_unit),
    },
    {
      label: "Tình trạng",
      value: (
        <span className="text-xs flex gap-1 mt-[2px]">
          {isOutOfStock ? (
            <span className="text-red-500">Hết hàng</span>
          ) : (
            <>
              <Image width={14} src={CC_ICON} alt="CC_ICON" />
              <span className="text-green-500">Còn hàng</span>
            </>
          )}
        </span>
      ),
    },
  ];

  return (
    <div className="text-small-regular py-4">
      <div className="grid grid-cols-2 gap-x-8 gap-y-4">
        {productInfo.map((item, index) => {
          return (
            <div key={index} className="flex flex-col gap-y-4">
              <div>
                <span className="font-semibold">{item.label}</span>
                <p>{item.value as ReactNode}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ProductParameterTab = ({ product }: ProductTabsProps) => {
  const productParameter = product?.variants?.[0]?.attribute_values?.map((o) => {
    return {
      label: o?.attribute?.name || "--",
      value: o?.value || "--",
    };
  });

  if (!productParameter) return null;

  const [expanded, setExpanded] = useState(false);

  const visibleItems = expanded ? productParameter : productParameter.slice(0, 4);

  return (
    <div className="text-small-regular py-4">
      <div className="grid grid-cols-2 gap-x-8 gap-y-4">
        {visibleItems.map((item, index) => {
          return (
            <div key={index} className="flex flex-col gap-y-4">
              <div>
                <span className="font-semibold">{item.label}</span>
                <p>{item.value || "-"}</p>
              </div>
            </div>
          );
        })}
      </div>
      {productParameter.length > 4 && (
        <button onClick={() => setExpanded(!expanded)} className="mt-2 text-primary-500 hover:underline">
          {expanded ? "Thu gọn" : "Xem thêm"}
        </button>
      )}
    </div>
  );
};

export default ProductTabs;
